import Vue from 'vue';
import Vuex from 'vuex';

// import router from '../router';

import { getTicket } from '@/api/user';
import { logout } from '@/api/login';

import { uploadRecord } from '@/api/video';
import { getUser, getUUid, setUser, setUUid, removeUser, removeUUid } from '@/utils/auth';

import permission from "./modules/permission";

Vue.use(Vuex);


const store = new Vuex.Store({
  state: {
    // userInfo: getUser(),
    userInfo: null,
    UUid: null,
  },
  getters: {
    getUserInfo({ userInfo }) {
      return userInfo || getUser();
    },
    getUUid({ UUid }) {
      return UUid || getUUid();
    },
  },
  mutations: {},
  actions: {
    setUserInfo({ state }, data) {
      state.userInfo = data;
      setUser(data);
    },
    setUUid({ state }, data) {
      state.UUid = data;
      setUUid(data);
    },
    removeUserInfo({ state }) {
      state.userInfo = null;
      removeUser();
    },
    removeUUid({ state }) {
      state.UUid = null;
      removeUUid();
    },
    removeAll({ dispatch }) {
      dispatch('removeUserInfo');
      dispatch('removeUUid');
    },
    async updateVideoTime(context, data) {
      await uploadRecord(data);
    },
    /**
     * 获取用户信息
     * @param {*} context 
     * @returns 
     */
    async getUserInfo(context) {
      console.log('getUserInfo:开始')
      const { getters, dispatch } = context;
      // 判断本地是否有缓存的用户信息或用户uuid为空（未进行登陆操作）
      if (getters.getUserInfo != null || getters.getUUid == null) {
        console.log('getUserInfo:本地缓存UserInfo', getters.getUserInfo)
        console.log('getUserInfo:本地缓存UUid', getters.getUUid)
        return;
      }
      // 利用uuid参数调用getTicket方法获取用户信息
      const res = await getTicket({ uuid: getters.getUUid });
      console.log('getUserInfo:getTicket', res)
      if (res.code == 0) {
        // 调用setUserInfo方法保存用户信息到vuex中
        dispatch('setUserInfo', res.data);
        // 如果是管理员用户，那么跳转到后台页面
        // if (res.data.isAdmin === 1) {
        //   router.replace('/admin/');
        // }
      }
      console.log('getUserInfo:结束')
    },
    /**
     * cas登出
     * @param {*} param0 
     */
    async longOut({ dispatch, getters }) {
      // alert('longout')
      const res = await logout({ uuid: getters.getUUid });
      // alert(res.code)
      if (res.code == 0) {
        // 移除用户信息、uuid
        // console.log('执行longOut，开始清楚本地缓存的用户信息与uuid')
        await dispatch('removeAll');
        // 清除本地关于cas认证的cookie
        // var cookies = document.cookie.split(";");
        // alert(document.cookie+'测试2开始')
        // console.log('document.cookie:',document.cookie)
        // for (var i = 0; i < cookies.length; i++) {
        //   var cookie = cookies[i];
        //   var eqPos = cookie.indexOf("=");
        //   var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        //   if (name.indexOf("authserver.nuaa.edu.cn") > -1) {
        //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=authserver.nuaa.edu.cn; path=/;";
        //   }
        // }
        // alert(document.cookie+'测试2结束')
        const href = `https://authserver.nuaa.edu.cn/authserver/logout`;
        // const href = `http://localhost:8080/cas-server-webapp-tomcat-5.3.16/logout`
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = href;
        a.target = '_blank';
        a.click();
        document.body.appendChild(a); // 将 <a> 元素添加到文档中
        // 等待一小段时间以确保浏览器打开了新窗口或标签页
        setTimeout(() => {
          document.body.removeChild(a); // 从文档中移除 <a> 元素
        }, 1000);
        window.location.reload();
      }
    },
  },
  modules: {
    permission
  }
});

export default store;
